import React, { useEffect, useState } from "react";
import "../Components/Dashboard.css";
import CommunicationReport from "./CommunicationReport";
import ClientWiseSummary from "./ClientWiseSummary";
import { BASE_URL } from "./apiConfig";

const Dashboard = () => {
    const [loading, setLoading] = useState(false);
    const [DashboardData, setDashboardData] = useState([]);
     const loginData = JSON.parse(sessionStorage.getItem("loginData"));
    const sessionusertype = loginData?.utype?.usertype;
    const sessionusername = loginData?.guiuserid;

    // const stats = [
    //     {
    //         title: "Today Submission",
    //         value: "1,864",
    //         growth: "12%",
    //         icon: <i class="fa-solid fa-calendar-day"></i>,
    //         iconClass: "dealer-icon"
    //     },
    //     {
    //         title: "Today Delivered",
    //         value: "3,416",
    //         growth: "10%",
    //         icon: <i class="fa-solid fa-calendar-check"></i>,
    //         iconClass: "credit-icon"
    //     },
    //     {
    //         title: "Current Month Submission",
    //         value: "17,351",
    //         growth: "8%",
    //         icon: <i class="fa-solid fa-calendar-days"></i>,
    //         iconClass: "communication-icon"
    //     },
    //     {
    //         title: "Last 2 Months Submission",
    //         value: "4,145",
    //         growth: "6%",
    //         icon: <i class="fa-regular fa-calendar-days"></i>,
    //         iconClass: "month-icon"
    //     }

    // ];

    // const hourlyData = [
    //     {
    //         label: "00:00",
    //         request: 120,
    //         submit: 115,
    //         delivered: 105,
    //         failed: 5
    //     },
    //     {
    //         label: "01:00",
    //         request: 180,
    //         submit: 170,
    //         delivered: 158,
    //         failed: 8
    //     },
    //     {
    //         label: "02:00",
    //         request: 220,
    //         submit: 210,
    //         delivered: 195,
    //         failed: 10
    //     }

    //     // ...
    // ];

    // const daywiseData = [
    //     {
    //         label: "2026-08-25",
    //         request: 6800000,
    //         submit: 6650000,
    //         delivered: 4750000,
    //         failed: 185000,
    //         rejected: 150000,
    //         awaited: 30000
    //     },
    //     {
    //         label: "2026-08-26",
    //         request: 2500000,
    //         submit: 2420000,
    //         delivered: 1800000,
    //         failed: 72000,
    //         rejected: 80000,
    //         awaited: 28000
    //     },
    //     {
    //         label: "2026-08-27",
    //         request: 2400000,
    //         submit: 2330000,
    //         delivered: 1750000,
    //         failed: 68000,
    //         rejected: 70000,
    //         awaited: 32000
    //     },
    //     {
    //         label: "2026-08-28",
    //         request: 5000000,
    //         submit: 4880000,
    //         delivered: 3850000,
    //         failed: 125000,
    //         rejected: 120000,
    //         awaited: 25000
    //     },
    //     {
    //         label: "2026-08-29",
    //         request: 1400000,
    //         submit: 1350000,
    //         delivered: 1200000,
    //         failed: 48000,
    //         rejected: 50000,
    //         awaited: 20000
    //     },
    //     {
    //         label: "2026-08-30",
    //         request: 1600000,
    //         submit: 1540000,
    //         delivered: 1300000,
    //         failed: 55000,
    //         rejected: 60000,
    //         awaited: 25000
    //     },
    //     {
    //         label: "2026-08-31",
    //         request: 2100000,
    //         submit: 2020000,
    //         delivered: 1650000,
    //         failed: 85000,
    //         rejected: 80000,
    //         awaited: 25000
    //     },
    //     {
    //         label: "2026-09-01",
    //         request: 2700000,
    //         submit: 2600000,
    //         delivered: 2150000,
    //         failed: 95000,
    //         rejected: 100000,
    //         awaited: 35000
    //     },
    //     {
    //         label: "2026-09-02",
    //         request: 2200000,
    //         submit: 2130000,
    //         delivered: 1950000,
    //         failed: 65000,
    //         rejected: 70000,
    //         awaited: 25000
    //     },
    //     {
    //         label: "2026-09-03",
    //         request: 1100000,
    //         submit: 1060000,
    //         delivered: 850000,
    //         failed: 42000,
    //         rejected: 40000,
    //         awaited: 18000
    //     },
    //     {
    //         label: "2026-09-04",
    //         request: 3000000,
    //         submit: 2900000,
    //         delivered: 2450000,
    //         failed: 115000,
    //         rejected: 100000,
    //         awaited: 35000
    //     },
    //     {
    //         label: "2026-09-05",
    //         request: 2100000,
    //         submit: 2020000,
    //         delivered: 1650000,
    //         failed: 85000,
    //         rejected: 80000,
    //         awaited: 25000
    //     },
    //     {
    //         label: "2026-09-06",
    //         request: 900000,
    //         submit: 860000,
    //         delivered: 780000,
    //         failed: 35000,
    //         rejected: 40000,
    //         awaited: 5000
    //     },
    //     {
    //         label: "2026-09-07",
    //         request: 850000,
    //         submit: 810000,
    //         delivered: 720000,
    //         failed: 38000,
    //         rejected: 40000,
    //         awaited: 12000
    //     },
    //     {
    //         label: "2026-09-08",
    //         request: 1200000,
    //         submit: 1150000,
    //         delivered: 980000,
    //         failed: 52000,
    //         rejected: 50000,
    //         awaited: 15000
    //     },
    //     {
    //         label: "2026-09-09",
    //         request: 800000,
    //         submit: 770000,
    //         delivered: 680000,
    //         failed: 35000,
    //         rejected: 30000,
    //         awaited: 10000
    //     },
    //     {
    //         label: "2026-09-10",
    //         request: 1100000,
    //         submit: 1050000,
    //         delivered: 900000,
    //         failed: 48000,
    //         rejected: 50000,
    //         awaited: 12000
    //     },
    //     {
    //         label: "2026-09-11",
    //         request: 4800000,
    //         submit: 4650000,
    //         delivered: 3950000,
    //         failed: 210000,
    //         rejected: 150000,
    //         awaited: 40000
    //     },
    //     {
    //         label: "2026-09-12",
    //         request: 5200000,
    //         submit: 5050000,
    //         delivered: 4100000,
    //         failed: 225000,
    //         rejected: 150000,
    //         awaited: 50000
    //     },
    //     {
    //         label: "2026-09-13",
    //         request: 4900000,
    //         submit: 4750000,
    //         delivered: 3900000,
    //         failed: 205000,
    //         rejected: 150000,
    //         awaited: 45000
    //     },
    //     {
    //         label: "2026-09-14",
    //         request: 4500000,
    //         submit: 4380000,
    //         delivered: 3850000,
    //         failed: 185000,
    //         rejected: 120000,
    //         awaited: 45000
    //     },
    //     {
    //         label: "2026-09-15",
    //         request: 5100000,
    //         submit: 4950000,
    //         delivered: 4350000,
    //         failed: 190000,
    //         rejected: 150000,
    //         awaited: 45000
    //     },
    //     {
    //         label: "2026-09-16",
    //         request: 4800000,
    //         submit: 4650000,
    //         delivered: 3900000,
    //         failed: 200000,
    //         rejected: 150000,
    //         awaited: 40000
    //     },
    //     {
    //         label: "2026-09-17",
    //         request: 6100000,
    //         submit: 5950000,
    //         delivered: 4750000,
    //         failed: 250000,
    //         rejected: 150000,
    //         awaited: 50000
    //     },
    //     {
    //         label: "2026-09-18",
    //         request: 6700000,
    //         submit: 6500000,
    //         delivered: 5050000,
    //         failed: 280000,
    //         rejected: 200000,
    //         awaited: 45000
    //     },
    //     {
    //         label: "2026-09-19",
    //         request: 6200000,
    //         submit: 6050000,
    //         delivered: 5150000,
    //         failed: 260000,
    //         rejected: 150000,
    //         awaited: 40000
    //     },
    //     {
    //         label: "2026-09-20",
    //         request: 5100000,
    //         submit: 4950000,
    //         delivered: 3900000,
    //         failed: 230000,
    //         rejected: 150000,
    //         awaited: 50000
    //     },
    //     {
    //         label: "2026-09-21",
    //         request: 5400000,
    //         submit: 5250000,
    //         delivered: 4400000,
    //         failed: 220000,
    //         rejected: 150000,
    //         awaited: 50000
    //     },
    //     {
    //         label: "2026-09-22",
    //         request: 6400000,
    //         submit: 6200000,
    //         delivered: 5200000,
    //         failed: 270000,
    //         rejected: 200000,
    //         awaited: 50000
    //     },
    //     {
    //         label: "2026-09-23",
    //         request: 5600000,
    //         submit: 5450000,
    //         delivered: 4750000,
    //         failed: 210000,
    //         rejected: 150000,
    //         awaited: 50000
    //     }
    // ];

    const getDashboardData = async () => {
        try {
            setLoading(true);

            const response = await fetch(
                `${BASE_URL}/Dashboard`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        userID: sessionusername,
                        utype: sessionusertype
                    })
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP Error: ${response.status}`);
            }

            const result = await response.json();

            console.log("Dashboard API Response:", result);

            if (result?.status !== "Success") {
                throw new Error(
                    result?.errorDesc || "Unable to fetch dashboard data"
                );
            }

            setDashboardData(result);

        } catch (err) {
            console.error("Dashboard API Error:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { getDashboardData(); }, []);

    const todayData = DashboardData?.todaylst || {};
    const currentMonthData = DashboardData?.currentmonthlst || {};
    const last2MonthData = DashboardData?.last2monthlst || {};
    const stats = [{ title: "Today Submission", value: Number(todayData?.submittedcount || 0).toLocaleString(), growth: "", icon: <i className="fa-solid fa-calendar-day"></i>, iconClass: "dealer-icon" }, { title: "Today Delivered", value: Number(todayData?.deliveredcount || 0).toLocaleString(), growth: "", icon: <i className="fa-solid fa-calendar-check"></i>, iconClass: "credit-icon" }, { title: "Current Month Submission", value: Number(currentMonthData?.submittedcount || 0).toLocaleString(), growth: "", icon: <i className="fa-solid fa-calendar-days"></i>, iconClass: "communication-icon" }, { title: "Last 2 Months Submission", value: Number(last2MonthData?.submittedcount || 0).toLocaleString(), growth: "", icon: <i className="fa-regular fa-calendar-days"></i>, iconClass: "month-icon" }];
    const hourlyData = (DashboardData?.hourlylst || []).map((item) => ({ label: `${String(item.hour).padStart(2, "0")}:00`, request: Number(item.submittedcount || 0), submit: Number(item.submittedcount || 0), delivered: Number(item.deliveredcount || 0), failed: Number(item.failedcount || 0), awaited: Number(item.awaitedcount || 0) }));
    const daywiseData = (DashboardData?.dailylst || []).map((item) => ({ label: item.reqdate, request: Number(item.submittedcount || 0), submit: Number(item.submittedcount || 0), delivered: Number(item.deliveredcount || 0), failed: Number(item.failedcount || 0), rejected: 0, awaited: Number(item.awaitedcount || 0) }));

    return (
        <div style={{ height: "auto", maxHeight: "42rem", overflowY: 'auto', position: "relative" }}>
            {loading && (
                <div className="spinner-overlay">
                    <div className="custom-spinner"></div>
                </div>
            )}
            <div className={loading ? "dashboard-stats-ribbon blurred" : "dashboard-stats-ribbon "} >
                <div className="ribbon-orange-corner ribbon-corner-left"></div>
                <div className="ribbon-orange-corner ribbon-corner-right"></div>

                {/* Small decorative dots */}
                <div className="ribbon-dots ribbon-dots-left"></div>
                <div className="ribbon-dots ribbon-dots-right"></div>

                <div className="dashboard-stats-grid">
                    {stats.map((item, index) => (
                        <div className="dashboard-stat-card" key={index}>
                            <div className={`dashboard-stat-icon ${item.iconClass}`}>
                                <span>{item.icon}</span>
                            </div>

                            <div className="dashboard-stat-content">
                                <div className="dashboard-stat-title">
                                    {item.title}
                                </div>

                                <div className="dashboard-stat-value">
                                    {item.value}
                                </div>

                                {/* <div className="dashboard-stat-growth">
                                    <span className="growth-arrow">↑</span>
                                    <span>{item.growth}</span>
                                </div> */}

                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div style={{ height: "100%", width: "100%" }} className={loading ? "blurred" : ""}>
                <CommunicationReport
                    hourlyData={hourlyData}
                    daywiseData={daywiseData}
                />
            </div>
            {/* <div style={{ height: "100%", width: "100%" }} className={loading ? "blurred" : ""}>
                <ClientWiseSummary />
            </div> */}
        </div>
    );
};

export default Dashboard;